document.addEventListener('DOMContentLoaded', function() {
    
    // Get all elements
    const panelTriggers = document.querySelectorAll('.panel-trigger');
    const sidePanels = document.querySelectorAll('.side-panel');
    const closeButtons = document.querySelectorAll('.side-panel__close');
    const overlay = document.querySelector('.panel-overlay');
    
    // Check if side panel functionality is needed on this page
    if (panelTriggers.length === 0 && sidePanels.length === 0) {
      console.log("Side panel functionality not needed on this page");
      return; // Exit early if no panels are present
    }
    
    // Check if overlay exists, create it if needed
    if (!overlay) {
      console.log("Panel overlay not found, side panel functionality disabled");
      return; // Exit if critical elements are missing
    }
    
    // Variable to track the currently open panel
    let activePanel = null;
    
    // Function to open a specific panel
    function openPanel(panelId) {
      // Close any open panel first
      if (activePanel) {
        closePanel();
      }
      
      // Get the panel to open
      const panel = document.getElementById('panel-' + panelId);
      if (!panel) return;
      
      // Get trigger button that was clicked
      const trigger = document.querySelector(`.panel-trigger[data-panel="${panelId}"]`);
      
      // Activate the panel and overlay
      panel.classList.add('active');
      overlay.classList.add('active');
      
      // Update ARIA attributes
      panel.setAttribute('aria-hidden', 'false');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      
      // Prevent body scrolling
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = '10px';
      
      // Set focus to the first focusable element in the panel
      setTimeout(() => {
        const focusableElements = panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (focusableElements.length) {
          focusableElements[0].focus();
        }
      }, 100);
      
      // Update active panel reference
      activePanel = panel;
    }
    
    // Function to close the active panel
    function closePanel() {
      if (!activePanel) return;
      
      // Get the panel ID to find corresponding trigger
      const panelId = activePanel.id.replace('panel-', '');
      const trigger = document.querySelector(`.panel-trigger[data-panel="${panelId}"]`);
      
      // Deactivate panel and overlay
      activePanel.classList.remove('active');
      overlay.classList.remove('active');
      
      // Update ARIA attributes
      activePanel.setAttribute('aria-hidden', 'true');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        // Return focus to the trigger button
        trigger.focus();
      }
      
      // Restore body scrolling
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      // Clear active panel reference
      activePanel = null;
    }
    
    // Add click event listeners to buttons
    panelTriggers.forEach(trigger => {
      trigger.addEventListener('click', function() {
        const panelId = this.getAttribute('data-panel');
        openPanel(panelId);
      });
    });
    
    // Add click event to all close buttons
    closeButtons.forEach(button => {
      button.addEventListener('click', closePanel);
    });
    
    // Close panel when clicking the overlay (only if overlay exists)
    if (overlay) {
      overlay.addEventListener('click', closePanel);
    }
    
    // Close panel with escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && activePanel) {
        closePanel();
      }
    });
    
    // Handle keyboard trap inside open panel for accessibility
    sidePanels.forEach(panel => {
      panel.addEventListener('keydown', function(e) {
        if (e.key === 'Tab') {
          // Get all focusable elements in the panel
          const focusableElements = panel.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          
          if (focusableElements.length === 0) return;
          
          const firstElement = focusableElements[0];
          const lastElement = focusableElements[focusableElements.length - 1];
          
          // If shift+tab pressed on first element, move to last element
          if (e.shiftKey && document.activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus();
          } 
          // If tab pressed on last element, loop to first element
          else if (!e.shiftKey && document.activeElement === lastElement) {
            e.preventDefault();
            firstElement.focus();
          }
        }
      });
    });
  });